import { Component, computed, inject, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { RdsFooterModule, RdsLinkModule } from '@rds/angular-components';
import { Router, RouterLink } from '@angular/router';
import { OfferingsService } from '../../../services/offerings.service';

@Component({
  selector: 'inexp-footer',
  imports: [StoryblokDirective, RdsFooterModule, RdsLinkModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();
  sitemap = input<any[]>([]);
  navigation = input<any>();
  disclaimer = input<string>();

  private readonly _offeringsService = inject(OfferingsService);

  categories = this._offeringsService.offeringCategories;
  categorySections = computed(() => {
    const cats = this.categories();
    const chunkSize = 10;
    const sections: any[][] = [];

    for (let i = 0; i < cats.length; i += chunkSize) {
      sections.push(cats.slice(i, i + chunkSize));
    }

    return sections;
  });


  navigate(category: string) {
    this.router.navigate(['/search'], {
      queryParams: { q: '', categories: category },
    });
  }
}
